import axios from 'axios';
// import serverUrl from '../serverUrl'
import * as settings from '../settings'

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV
const instance = axios.create({
    baseURL: serverUrl,//'https://effective1srv.eu.ngrok.io',//'http://localhost:4000'
    withCredentials: true
});

export default instance;